<template>
  <section>
    <div v-if="airline && airline.params">
      <div v-if="lang && lang['taxi']" class="option-container">
        <!-- Address Info -->
        <div class="address-info">
          <div v-if="!setOptionTaxi" class="group-taxi-form mb-1">
            <div class="row">
              <div class="list-option col-md-6 col-12">
                <div class="item-option">
                  <fieldset>
                    <legend>{{ lang['taxi'].SFS_LANG_ROW_2 }}</legend>

                    <div class="item-option">
                      <div class="el-radio el-radio-green d-flex">
                        <input
                          id="one-way-hotel"
                          v-model="optionTaxi"
                          :disabled="setOptionTaxi"
                          name="option-taxi"
                          value="1"
                          type="radio"
                          class="form-control"
                          :aria-label="lang['taxi'].SFS_LANG_ROW_3"
                        />
                        <label class="el-radio-style" for="one-way-hotel">
                          <span class="sr-only">{{ lang['taxi'].SFS_LANG_ROW_3 }}</span>
                        </label>
                        <span class="pl-2">{{ lang['taxi'].SFS_LANG_ROW_3 }}</span>
                      </div>
                    </div>

                    <div class="item-option">
                      <div class="el-radio el-radio-green d-flex">
                        <input
                          id="two-way"
                          v-model="optionTaxi"
                          :disabled="setOptionTaxi"
                          name="option-taxi"
                          value="2"
                          type="radio"
                          class="form-control"
                          :aria-label="lang['taxi'].SFS_LANG_ROW_4"
                        />
                        <label class="el-radio-style" for="two-way">
                          <span class="sr-only">{{ lang['taxi'].SFS_LANG_ROW_4 }}</span>
                        </label>
                        <span class="pl-2">{{ lang['taxi'].SFS_LANG_ROW_4 }}</span>
                      </div>
                    </div>

                    <div class="item-option">
                      <div class="el-radio el-radio-green d-flex">
                        <input
                          id="one-way-airport"
                          v-model="optionTaxi"
                          :disabled="setOptionTaxi"
                          name="option-taxi"
                          value="3"
                          type="radio"
                          class="form-control"
                          :aria-label="lang['taxi'].SFS_LANG_ROW_5"
                        />
                        <label class="el-radio-style" for="one-way-airport">
                          <span class="sr-only">{{ lang['taxi'].SFS_LANG_ROW_5 }}</span>
                        </label>
                        <span class="pl-2">{{ lang['taxi'].SFS_LANG_ROW_5 }}</span>
                      </div>
                    </div>

                    <div class="item-option">
                      <div class="el-radio el-radio-green d-flex">
                        <input
                          id="way-other"
                          v-model="optionTaxi"
                          :disabled="setOptionTaxi"
                          name="option-taxi"
                          value="4"
                          type="radio"
                          class="form-control"
                          :aria-label="lang['taxi'].SFS_LANG_ROW_8"
                        />
                        <label class="el-radio-style" for="way-other">
                          <span class="sr-only">{{ lang['taxi'].SFS_LANG_ROW_8 }}</span>
                        </label>
                        <span class="pl-2">{{ lang['taxi'].SFS_LANG_ROW_8 }}</span>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div v-if="!setOptionTaxi" style="min-height: 4rem">
              <div v-if="optionTaxi != 4 && !PaxsHotel">{{ lang['taxi'].SFS_LANG_ROW_7 }}</div>
              <div v-else>
                <div v-if="optionTaxi == 3">
                  <p>
                    <span v-html="replaceStr(lang['taxi'].SFS_LANG_ROW_6, ['<airport_name>'], [airline.airport_name])"></span>
                  </p>
                </div>
              </div>
              <fieldset>
                <legend class="sr-only">{{ lang['taxi'].SFS_LANG_ROW_9 }}</legend>

                <div slot="option-way-other" class="d-flex justify-content-center mt-3">
                  <div class="form-check mr-3">
                    <div class="el-radio el-radio-green d-flex">
                      <input
                        id="two-way-other"
                        v-model="way_option"
                        name="way-other"
                        value="2"
                        :disabled="optionTaxi != list_taxi_option.AIRPORT_ADDRESS || setOptionTaxi"
                        type="radio"
                        class="form-control"
                        :aria-label="lang['taxi'].SFS_LANG_ROW_11"
                      />
                      <label class="el-radio-style" for="two-way-other">
                        <span class="sr-only">{{ lang['taxi'].SFS_LANG_ROW_11 }}</span>
                      </label>
                      <span class="pl-2">{{ lang['taxi'].SFS_LANG_ROW_11 }}</span>
                    </div>
                  </div>

                  <div class="form-check">
                    <div class="el-radio el-radio-green d-flex">
                      <input
                        id="one-way-other"
                        v-model="way_option"
                        name="way-other"
                        value="1"
                        :disabled="optionTaxi != list_taxi_option.AIRPORT_ADDRESS || setOptionTaxi"
                        type="radio"
                        class="form-control"
                        :aria-label="lang['taxi'].SFS_LANG_ROW_10"
                      />
                      <label class="el-radio-style" for="one-way-other">
                        <span class="sr-only">{{ lang['taxi'].SFS_LANG_ROW_10 }}</span>
                      </label>
                      <span class="pl-2">{{ lang['taxi'].SFS_LANG_ROW_10 }}</span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="mb-2">
              <AddressInfo
                :address-title="addressTitle"
                :origin="origin"
                :destination="destination"
                :init-show-map="false"
                @updateLocation="updateLocation"
                @getPriceByDistance="getPriceByDistance"
                @clearDestinationAddress="clearDestinationAddress"
              ></AddressInfo>
            </div>
          </div>
        </div>
        <div v-show="needShareTaxi" class="needed-taxis">
          <h2 class="title-choose-photo">
            <u>{{ lang['taxi'].SFS_LANG_ROW_16 }}</u>
          </h2>
          <div class="my-3 select-needed-taxis d-flex justify-content-start">
            <v-select
              v-model="numberOfTaxies"
              class="ws-drop-down ws-drop-down--desktop"
              :disabled="isAirlineSet"
              :clearable="false"
              :searchable="false"
              :filterable="false"
              :options="optionSelect"
            ></v-select>
          </div>
        </div>
        <!-- Share taxi matrix -->
        <div v-show="needShareTaxi" class="share-taxi-matrix">
          <h2 class="title-choose-photo">
            <u>{{ lang['taxi'].SFS_LANG_ROW_17 }}</u>
          </h2>
          <ShareMatrix
            :number="numberOfTaxies"
            :list-pax="listPax"
            :is-airline-set="isAirlineSet"
            :airline-matrix="airlineShareMatrix"
            @getListSelected="getListSelected"
          />
        </div>
        <!-- Reserve button -->
        <div class="text-center pt-3">
          <button class="book-taxi ws-btn hd-normal-btn-background-color hd-normal-btn-color" @click="confirmTaxi()">
            {{ lang['taxi'].SFS_LANG_ROW_20 }}
          </button>
        </div>
      </div>
      <b-alert
        v-model="showAlertTop"
        :v-show="messagesError.leng"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
        variant="danger"
        dismissible
      >
        <div v-for="(error, index) in messagesError" :key="index">
          <div>{{ error }}</div>
        </div>
      </b-alert>
    </div>
  </section>
</template>
<script>
import '@/assets/scss/modules/OptionTaxi.scss'
import { mapGetters } from 'vuex'
import AddressInfo from '@/components/AddressInfo/index'
import ShareMatrix from './ShareMatrix'
import { replaceStr } from '@/utils/helper'
import * as _ from 'lodash'

const ONE_AIRPORT_HOTEL = 1
const TWO_AIRPORT_HOTEL = 2
const ONE_HOTEL_AIRPORT = 3
const AIRPORT_ADDRESS = 4

const ONE_WAY = 1
const TWO_WAY = 2

const PHOTO2CALIM = 'photo2claim'

export default {
  name: 'OptionTaxi',
  components: { AddressInfo, ShareMatrix },
  props: {
    secret: {
      type: String,
      default: ''
    },
    indexBooking: {
      type: Number,
      default: 0
    },
    overnightStation: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      taxiBookingDetail: {},
      taxiPrice: 0,
      distanceTaxi: 0,
      totalPrice: 0,
      priceHotelToAirport: 0,
      priceAirportToHotel: 0,
      dataDistance: {},
      distanceHotelToAirport: 0,
      distanceAirportToHotel: 0,
      locationInput: {},
      isShowMap: false,
      listPax: [],
      taxiService: {},
      currency: '',
      // Pick up time
      timePickup: {
        HH: '00',
        mm: '00'
      },
      nextDayState: false,
      // Needed taxis
      needShareTaxi: false,
      pax_per_taxi: 0,
      numberOfTaxies: 0,
      optionSelect: [],
      airlineShareMatrix: [],
      isAirlineSet: false,
      shareTaxiMatrix: [],

      // Option taxi
      way_option: ONE_WAY,
      list_taxi_option: {
        ONE_AIRPORT_HOTEL: ONE_AIRPORT_HOTEL,
        TWO_AIRPORT_HOTEL: TWO_AIRPORT_HOTEL,
        ONE_HOTEL_AIRPORT: ONE_HOTEL_AIRPORT,
        AIRPORT_ADDRESS: AIRPORT_ADDRESS
      },
      optionTaxi: AIRPORT_ADDRESS,
      setOptionTaxi: false,
      addressTitle: {},
      // contact Info
      shareMatrixInfo: [],
      // Alert
      showAlertTop: false,
      messagesError: []
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      PaxsHotel: 'SelectRoom/PaxsHotel',
      Voucher: 'Taxi/Voucher'
    }),
    hasVoucherHotel() {
      let hotelService = _.find(this.Services, { service_id: 1 })
      if (hotelService.params && hotelService.params.hotel_name) {
        return true
      }
      return false
    },
    origin() {
      let self = this
      let overnight_station = self.overnightStation
      if (!_.isEmpty(self.taxiBookingDetail) && !_.isUndefined(self.taxiBookingDetail.origin) && self.taxiBookingDetail.origin) {
        return self.taxiBookingDetail.origin
      }
      let location = {}
      switch (parseInt(self.optionTaxi)) {
        case ONE_AIRPORT_HOTEL:
        case TWO_AIRPORT_HOTEL:
        case AIRPORT_ADDRESS:
          if (self.airline) {
            location = {
              lat: parseFloat(!_.isEmpty(overnight_station) ? overnight_station.geo_lat : self.airline.geo_lat),
              lng: parseFloat(!_.isEmpty(overnight_station) ? overnight_station.geo_lon : self.airline.geo_lon),
              display_address: !_.isEmpty(overnight_station) ? overnight_station.name : self.airline.airport_name,
              disabled: true
            }
          }
          break
        case ONE_HOTEL_AIRPORT:
          if (!_.isEmpty(self.PaxsHotel)) {
            location = {
              lat: parseFloat(self.PaxsHotel.geo_lat),
              lng: parseFloat(self.PaxsHotel.geo_long),
              display_address: self.PaxsHotel.address,
              disabled: true
            }
          } else {
            location = {
              lat: '',
              lng: '',
              display_address: '',
              disabled: true
            }
          }
          break
        default:
          break
      }

      return location
    },
    destination() {
      let self = this
      let overnight_station = self.overnightStation
      if (
        !_.isEmpty(self.taxiBookingDetail) &&
        !_.isUndefined(self.taxiBookingDetail.destination) &&
        self.taxiBookingDetail.destination
      ) {
        return self.taxiBookingDetail.destination
      }
      let location = {}
      switch (parseInt(self.optionTaxi)) {
        case ONE_AIRPORT_HOTEL:
        case TWO_AIRPORT_HOTEL:
          if (!_.isEmpty(self.PaxsHotel)) {
            location = {
              lat: parseFloat(self.PaxsHotel.geo_lat),
              lng: parseFloat(self.PaxsHotel.geo_long),
              display_address: self.PaxsHotel.address,
              disabled: true
            }
          } else {
            location = {
              lat: '',
              lng: '',
              display_address: '',
              disabled: true
            }
          }
          break
        case ONE_HOTEL_AIRPORT:
          if (!_.isEmpty(self.airline)) {
            location = {
              lat: parseFloat(!_.isEmpty(overnight_station) ? overnight_station.geo_lat : self.airline.geo_lat),
              lng: parseFloat(!_.isEmpty(overnight_station) ? overnight_station.geo_lon : self.airline.geo_lon),
              display_address: !_.isEmpty(overnight_station) ? overnight_station.name : self.airline.airport_name,
              disabled: true
            }
          }
          break
        case AIRPORT_ADDRESS:
          if (!_.isEmpty(self.locationInput)) {
            location = self.locationInput
          }
          break
        default:
          break
      }
      return location
    }
  },
  watch: {
    optionTaxi: function (option) {
      switch (parseFloat(option)) {
        case ONE_AIRPORT_HOTEL:
        case ONE_HOTEL_AIRPORT:
        case AIRPORT_ADDRESS:
          this.way_option = ONE_WAY
          break
        case TWO_AIRPORT_HOTEL:
          this.way_option = TWO_WAY
          break
        default:
          break
      }
    },
    way_option: function (way) {
      this.totalPrice = way == 1 ? this.taxiPrice : this.priceHotelToAirport + this.priceAirportToHotel
    },
    showAlertTop() {
      if (this.showAlertTop) {
        setTimeout(() => {
          this.showAlertTop = false
        }, 5000)
      }
    }
  },
  beforeMount() {
    this.initData()
  },
  methods: {
    replaceStr,
    initData() {
      let self = this
      if (
        !_.isUndefined(self.airline.airline_airport_detail) &&
        self.airline.airline_airport_detail &&
        !_.isEmpty(self.airline.airline_airport_detail)
      ) {
        self.currency =
          !_.isEmpty(self.airline.airline_airport_detail.currency_code) &&
          !_.isUndefined(self.airline.airline_airport_detail.currency_code) &&
          self.airline.airline_airport_detail.currency_code
            ? self.airline.airline_airport_detail.currency_code
            : self.taxiService.currency
      }
      self.curPaxId = self.pax.id || self.pax.curPaxID
      //
      if (!_.isEmpty(self.PaxsGroup) && !_.isEmpty(self.Services) && !_.isNull(self.Voucher)) {
        self.listPax = _.clone(self.PaxsGroup)
        self.checkPaxOnTaxi()
      }
      // Filter the taxi service
      self.taxiService = _.find(self.Services, function (service) {
        return service.service_id == 4
      })
      // Option taxi
      if (!_.isEmpty(self.taxiService)) {
        if (!_.isUndefined(self.taxiService.store_taxi_option) && self.taxiService.store_taxi_option) {
          self.optionTaxi = parseInt(self.taxiService.store_taxi_option)
        }
        if (!_.isUndefined(self.taxiService.taxi_booking_detail) && self.taxiService.taxi_booking_detail.length) {
          self.way_option = parseInt(self.taxiService.taxi_booking_detail.length)
          self.gettaxiBookingDetail()
        }
      }
      if (!_.isEmpty(self.Voucher) && typeof self.Voucher == 'object') {
        let keys = Object.keys(self.Voucher)
        let voucher =
          !_.isUndefined(self.Voucher[self.curPaxId]) && self.Voucher[self.curPaxId]
            ? self.Voucher[self.curPaxId]
            : self.Voucher[keys[0]]
        self.optionTaxi =
          !_.isUndefined(voucher.option_taxi) && voucher.option_taxi ? parseInt(voucher.option_taxi) : AIRPORT_ADDRESS
        self.setOptionTaxi = true
      }
      // check the share taxi matrix
      let matrixShareTaxi =
        !_.isUndefined(self.taxiService) && self.taxiService.params && self.taxiService.params.matrix_share_taxi
          ? [...self.taxiService.params.matrix_share_taxi]
          : []
      self.pax_per_taxi =
        !_.isEmpty(self.airline) && !_.isEmpty(self.airline.params) && self.airline.params.pax_per_taxi
          ? self.airline.params.pax_per_taxi
          : 0
      if (self.PaxsGroup && self.PaxsGroup.length <= self.pax_per_taxi) {
        let shareGroup = _.map(self.PaxsGroup, function (pax) {
          return 1
        })
        self.analyzeSelectedPaxsToGetGroupPax(shareGroup)
      } else if (!matrixShareTaxi.length && self.PaxsGroup && self.PaxsGroup.length > self.pax_per_taxi) {
        self.needShareTaxi = true
        self.airlineShareMatrix = []
      } else {
        self.needShareTaxi = true
        self.setAirlineShareMatrix(matrixShareTaxi)
      }
      if (self.lang && self.lang['taxi']) {
        self.addressTitle = {
          FROM: self.lang['taxi'].SFS_LANG_ROW_12,
          DISTANCE: self.lang['taxi'].SFS_LANG_ROW_9,
          TO: self.lang['taxi'].SFS_LANG_ROW_13,
          SHOW_MAP: self.lang['taxi'].SFS_LANG_ROW_14,
          HIDE_MAP: self.lang['taxi'].SFS_LANG_ROW_15,
          INPUT_PLACEHOLDER: self.lang['taxi'].SFS_LANG_ROW_24
        }
      }
    },
    gettaxiBookingDetail() {
      let self = this
      let voucher = self.Voucher[_.first(_.keys(self.Voucher))]
      if (_.isUndefined(voucher)) {
        return
      }
      let start_point = JSON.parse(voucher.start_point)
      let end_point = JSON.parse(voucher.end_point)
      let origin = {
        lat: start_point.Lat,
        lng: start_point.Lon,
        display_address: voucher.from_andress,
        disabled: true
      }
      let destination = {
        lat: end_point.Lat,
        lng: end_point.Lon,
        display_address: voucher.to_address,
        disabled: true
      }
      self.taxiBookingDetail = {
        way: self.indexBooking,
        type: self.indexBooking,
        est_amount: voucher.est_amount,
        currency: voucher.currency,
        // indexBooking = 0 (airport -> hotel)
        // if indexBooking = 1 (hotel -> airport), we need to reverse the origin and destination address taken from the Voucher
        origin: self.indexBooking ? destination : origin,
        destination: self.indexBooking ? origin : destination
      }
    },

    // check passenger in order to set the number of taxis
    checkPaxOnTaxi() {
      let self = this
      let maximumPax = self.airline.params.pax_per_taxi || 0
      let maximunNeededTaxis = self.listPax.length
      let miximunNeededTaxies = Math.ceil(maximunNeededTaxis / maximumPax)
      self.numberOfTaxies = miximunNeededTaxies
      if (self.numberOfTaxies) {
        self.optionSelect = _.range(miximunNeededTaxies, maximunNeededTaxis + 1)
      }
    },

    // convert from matrix_share_taxi to selected passengers
    setAirlineShareMatrix(matrix) {
      let self = this
      if (!matrix.length || !self.listPax.length) {
        return
      }
      let airlineMatrix = _.map(self.listPax, function (pax) {
        for (let idx = 0; idx < matrix.length; idx++) {
          let temGroup = matrix[idx]
          temGroup = temGroup.map((value) => parseInt(value))
          let paxId = pax.passenger_id
          if (_.indexOf(temGroup, parseInt(paxId)) >= 0) {
            return idx + 1
          }
        }
      })
      if (airlineMatrix.length) {
        self.airlineShareMatrix = airlineMatrix
        self.numberOfTaxies = _.uniq(airlineMatrix).length
        self.isAirlineSet = true
      }
    },

    getListSelected(data) {
      let self = this

      let paxPerTaxi = _.groupBy(data)
      let checkOverPax = _.some(paxPerTaxi, function (group) {
        return group.length > self.pax_per_taxi
      })
      if (checkOverPax) {
        let tempLang = self.lang['taxi'].SFS_LANG_ROW_18
        self.$swal(self.replaceStr(tempLang, '<pax_per_tax>', self.pax_per_taxi))
      }
      this.analyzeSelectedPaxsToGetGroupPax(data)
    },
    analyzeSelectedPaxsToGetGroupPax(group) {
      let self = this
      let shareMatrix = {}
      let shareMatrixInfo = {}
      _.each(group, function (key, index) {
        let pax = self.PaxsGroup[index]
        if (!shareMatrix[key]) {
          shareMatrix[key] = []
        }
        if (!shareMatrixInfo[key]) {
          shareMatrixInfo[key] = []
        }
        shareMatrix[key].push(pax.passenger_id.toString())

        let paxInfo = {
          passenger_id: pax.passenger_id,
          first_name: pax.first_name,
          last_name: pax.last_name,
          phone_number: pax.phone_number
        }
        shareMatrixInfo[key].push(paxInfo)
      })

      if (typeof shareMatrix == 'object') {
        shareMatrix = Object.values(shareMatrix)
      }
      if (typeof shareMatrixInfo == 'object') {
        shareMatrixInfo = Object.values(shareMatrixInfo)
      }
      if (shareMatrix.length) {
        self.shareTaxiMatrix = shareMatrix
      }
      if (shareMatrixInfo.length) {
        _.each(shareMatrixInfo, function (group) {
          let check = self.checkValidPhoneNumberForEachGroup(group)
          _.each(group, function (pax) {
            pax.is_valid_phone = check
          })
        })
        self.shareMatrixInfo = shareMatrixInfo
      }
    },
    checkValidPhoneNumberForEachGroup(group) {
      for (let idx = 0; idx < group.length; idx++) {
        let pax = group[idx]
        if (pax.phone_number) {
          return true
        }
      }
      return false
    },
    async confirmTaxi() {
      this.messagesError = []
      let self = this
      // check locationInput
      if (self.optionTaxi == AIRPORT_ADDRESS) {
        if (!self.locationInput.display_address || !self.locationInput.lat || !self.locationInput.lng) {
          this.messagesError.push('Please enter the address')
          this.showAlertTop = true
          return
        }
      }
      if (this.way_option == TWO_WAY) {
        // không getDirection nếu option taxi liên quan đến hotel nhưng pax không có hotel service
        if (this.optionTaxi == AIRPORT_ADDRESS || !_.isEmpty(this.PaxsHotel)) {
          await this.getDirection()
        }
      }
      if (!_.isEmpty(this.taxiBookingDetail)) {
        // Send SMS for the orther group passenger when Issued vouchers are already being
        await this.sendSMSForGroupPax()
      } else if (this.optionTaxi != 4 && _.isEmpty(this.PaxsHotel)) {
        // if empty hotel voucher, store option taxi
        await this.saveOptionTaxi()
      } else {
        // issue taxi
        await this.issueTaxi()
      }
    },
    async sendSMSForGroupPax() {
      let self = this
      let overnight_station = self.overnightStation
      let listPax = []
      if (self.PaxsGroup.length > 0) {
        listPax = _.map(self.PaxsGroup, 'passenger_id')
      }
      let phoneList = self.getPhoneList()
      let passengers = []
      _.forEach(self.PaxsGroup, function (item, index) {
        let pax = {
          option_taxi: self.optionTaxi,
          way_option: self.way_option,
          total_price: self.totalPrice,
          price_hotel_to_airport: self.priceHotelToAirport ?? 0,
          price_airport_to_hotel: self.priceAirportToHotel ?? 0,
          distance: self.distanceTaxi,
          distance_hotel_to_airport: self.distanceHotelToAirport ?? 0,
          distance_airport_to_hotel: self.distanceAirportToHotel ?? 0,
          hotel_id: !_.isEmpty(self.PaxsHotel) ? self.PaxsHotel.hotel_id : 0,
          currency: self.airline.currency_code,
          show_voucher: true,
          airport_code: !_.isEmpty(overnight_station) ? overnight_station.code : item.dep,
          passenger_id: item.passenger_id,
          phone_number: typeof item.phone_number == 'string' ? item.phone_number.replace(/\s+/g, '') : item.phone_number,
          from_andress: !_.isEmpty(overnight_station) ? overnight_station.name : self.airline.airport_name,
          from_geo_lat_lon: !_.isEmpty(overnight_station)
            ? `${overnight_station.geo_lat}, ${overnight_station.geo_lon}`
            : `${self.airline.geo_lat}, ${self.airline.geo_lon}`,
          is_auto_taxi: true
        }
        switch (parseInt(self.optionTaxi)) {
          case ONE_AIRPORT_HOTEL:
          case TWO_AIRPORT_HOTEL:
            pax.to_address = self.PaxsHotel.address
            pax.to_geo_lat_lon = `${self.PaxsHotel.geo_lat}, ${self.PaxsHotel.geo_long}`
            break
          case ONE_HOTEL_AIRPORT:
            pax.from_andress = !_.isUndefined(self.PaxsHotel) ? self.PaxsHotel.address : self.origin.display_address
            pax.from_geo_lat_lon = !_.isUndefined(self.PaxsHotel)
              ? `${self.PaxsHotel.geo_lat}, ${self.PaxsHotel.geo_long}`
              : `${self.origin.lat}, ${self.origin.lng}`
            pax.to_address = !_.isEmpty(overnight_station) ? overnight_station.name : self.airline.airport_name
            pax.to_geo_lat_lon = !_.isEmpty(overnight_station)
              ? `${overnight_station.geo_lat},${overnight_station.geo_lon}`
              : `${self.airline.geo_lat},${self.airline.geo_lon}`
            break
          case AIRPORT_ADDRESS:
            if (!_.isEmpty(self.locationInput)) {
              pax.to_address = self.locationInput.display_address
              pax.to_geo_lat_lon = `${self.locationInput.lat}, ${self.locationInput.lng}`
            } else {
              if (!_.isEmpty(self.taxiBookingDetail)) {
                pax.to_address = self.taxiBookingDetail.destination.display_address
                pax.to_geo_lat_lon = `${self.taxiBookingDetail.destination.lat}, ${self.taxiBookingDetail.destination.lng}`
              }
            }
            break
          default:
            break
        }
        passengers.push(pax)
      })
      let data = {
        passenger_id: listPax,
        matrix_share_taxi: self.shareTaxiMatrix,
        phone_list: phoneList,
        passengers: passengers
      }
      let dataSend = {
        data: data
      }
      await self.$store.dispatch('Taxi/sendSMSToOthers', dataSend).then(function (response) {
        if (response.success) {
          self.$store.dispatch('Home/getPaxsGroup')
          self.$emit('updateState')
        } else {
          let confirm = self.$swal(response.message || 'Action falied.')
          confirm.then((result) => {
            if (result.value) {
              self.$router.push({ path: '/home', query: { secret: self.secret } })
            }
          })
        }
      })
      let routeName = 'TaxiService'
      if (this.way_option == TWO_WAY || self.shareTaxiMatrix.length > 1) {
        routeName = 'Home'
      }
      self.$router.push({ name: routeName, query: { secret: self.secret } })
    },
    async saveOptionTaxi() {
      let self = this
      let listPax = []
      if (self.PaxsGroup.length > 0) {
        listPax = _.map(self.PaxsGroup, 'passenger_id')
      }
      let data = {
        passenger_id: listPax,
        taxi_option: self.optionTaxi,
        matrix_share_taxi: self.shareTaxiMatrix
      }
      let dataSend = {
        data: data
      }
      await self.$store.dispatch('Taxi/updateTaxiOption', dataSend).then(function (res) {
        if (res.success == true) {
          const hotel = _.find(self.Services, { service_id: 1 })
          if (!_.isEmpty(self.taxiBookingDetail)) {
            self.$emit('updateState')
          } else if (hotel && _.isUndefined(hotel?.params?.has_cancelled_hotel_voucher)) {
            self.$router.push({ path: '/hotel-list', query: { secret: self.secret } })
          } else {
            self.confirmAndNavigateToHomePage()
          }
        }
      })
    },
    confirmAndNavigateToHomePage() {
      const confirm = this.$swal(this.lang['taxi'].SFS_LANG_ROW_21)
      confirm.then((result) => {
        if (result.value) {
          this.$router.push({ path: '/home', query: { secret: this.secret } })
        }
      })
    },

    // issue the taxi voucher
    clearDestinationAddress() {
      Object.keys(this.locationInput).forEach((key) => {
        this.locationInput[key] = null
      })
    },
    async issueTaxi() {
      let self = this
      let overnight_station = self.overnightStation

      let passengers = []
      _.forEach(self.PaxsGroup, function (item) {
        let pax = {
          option_taxi: self.optionTaxi,
          way_option: self.way_option,
          total_price: self.totalPrice,
          total_price_change: self.totalPrice,
          price_hotel_to_airport: self.priceHotelToAirport ?? 0,
          price_airport_to_hotel: self.priceAirportToHotel ?? 0,
          distance: self.distanceTaxi,
          distance_hotel_to_airport: self.distanceHotelToAirport ?? 0,
          distance_airport_to_hotel: self.distanceAirportToHotel ?? 0,
          hotel_id: !_.isEmpty(self.PaxsHotel) ? self.PaxsHotel.hotel_id : 0,
          currency: self.currency,
          show_voucher: true,
          airport_code: !_.isEmpty(overnight_station) ? overnight_station.code : item.dep,
          passenger_id: item.passenger_id,
          phone_number: typeof item.phone_number == 'string' ? item.phone_number.replace(/\s+/g, '') : item.phone_number,
          from_andress: !_.isEmpty(overnight_station) ? overnight_station.name : self.airline.airport_name,
          from_geo_lat_lon: `${!_.isEmpty(overnight_station) ? overnight_station.geo_lat : self.airline.geo_lat}, ${
            !_.isEmpty(overnight_station) ? overnight_station.geo_lon : self.airline.geo_lon
          }`
        }

        switch (parseInt(self.optionTaxi)) {
          case ONE_AIRPORT_HOTEL:
          case TWO_AIRPORT_HOTEL:
            pax.to_address = self.PaxsHotel.address
            pax.to_geo_lat_lon = `${self.PaxsHotel.geo_lat}, ${self.PaxsHotel.geo_long}`
            break
          case ONE_HOTEL_AIRPORT:
            pax.from_andress = self.PaxsHotel.address
            pax.from_geo_lat_lon = `${self.PaxsHotel.geo_lat}, ${self.PaxsHotel.geo_long}`
            pax.to_address = !_.isEmpty(overnight_station) ? overnight_station.name : self.airline.airport_name
            pax.to_geo_lat_lon = `${overnight_station.geo_lat}, ${overnight_station.geo_lon}`
            break
          case AIRPORT_ADDRESS:
            if (!_.isEmpty(self.locationInput)) {
              pax.to_address = self.locationInput.display_address
              pax.to_geo_lat_lon = `${self.locationInput.lat}, ${self.locationInput.lng}`
            } else {
              if (!_.isEmpty(self.taxiBookingDetail)) {
                pax.to_address = self.taxiBookingDetail.destination.display_address
                pax.to_geo_lat_lon = `${self.taxiBookingDetail.destination.lat}, ${self.taxiBookingDetail.destination.lng}`
              }
            }
            break
          default:
            break
        }
        passengers.push(pax)
      })
      let dataSend = {
        data: {
          passengers: passengers,
          matrix_share_taxi: self.shareTaxiMatrix,
          secret: self.secret
        }
      }
      await self.$store.dispatch('Taxi/issueTaxi', dataSend).then(function (response) {
        if (response.success) {
          self.$emit('updateState')
        } else {
          let confirm = self.$swal(response.message)
          confirm.then((result) => {
            if (result.value) {
              if (self.$route.name != 'Home') {
                self.$router.push({ name: 'Home', query: { secret: self.secret } })
              }
            }
          })
        }
      })
      let routeName = 'TaxiService'
      if (this.way_option == TWO_WAY || self.shareTaxiMatrix.length > 1) {
        routeName = 'Home'
      }
      if (routeName !== this.$route.name) {
        self.$router.push({ name: routeName, query: { secret: self.secret } })
      }
    },
    updatePhoneNumber(data) {
      let self = this
      let pax = _.find(self.PaxsGroup, { passenger_id: parseInt(data.passenger_id) })
      if (data.phone_number && data.is_valid_phone) {
        pax.phone_number = typeof data.phone_number == 'string' ? data.phone_number.replace(/\s+/g, '') : data.phone_number
      } else {
        pax.phone_number = null
      }
    },
    getPhoneList() {
      let self = this
      let phoneList = []
      _.each(self.PaxsGroup, function (pax) {
        if (pax.phone_number) {
          let phone = {
            id: pax.passenger_id,
            phone_number: pax.phone_number
          }
          phoneList.push(phone)
        }
      })
      return phoneList
    },
    // check valid phone number of the groups
    checkPhoneNumberForEachGroup() {
      let self = this
      for (let idx = 0; idx < self.shareTaxiMatrix.length; idx++) {
        let valid = false
        let group = self.shareTaxiMatrix[idx]
        for (let jdx = 0; jdx < group.length; jdx++) {
          let paxId = group[jdx]
          let pax = _.find(self.PaxsGroup, { passenger_id: parseInt(paxId) })
          if (pax.phone_number) {
            valid = true
          }
        }
        if (!valid) {
          return false
        }
      }
      return true
    },

    /**
     * Address Info
     */
    // Update the selected location
    updateLocation(location) {
      if (location.destination) {
        this.locationInput = {
          lat: parseFloat(location.destination.lat),
          lng: parseFloat(location.destination.lng),
          display_address: location.destination.address
        }
      }
    },
    // estimate the distance and price
    getPriceByDistance(distance) {
      let priceTaxi = 0
      let overnight_station = this.overnightStation
      if (distance) {
        let taxiConfig = this.airline.params.airline_config_taxi
        let taxiAirportConfig = overnight_station.airline_airport_detail
        let km_rate_airline = Number(taxiConfig.km_rate) !== 0 ? taxiConfig.km_rate : 3
        let starting_tariff_airline = Number(taxiConfig.starting_tariff) !== 0 ? taxiConfig.starting_tariff : 0
        let km_rate =
          !_.isEmpty(taxiAirportConfig.km_rate) && Number(taxiAirportConfig.km_rate) !== 0
            ? taxiAirportConfig.km_rate
            : km_rate_airline
        let starting_tariff =
          !_.isEmpty(taxiAirportConfig.starting_tariff) && Number(taxiAirportConfig.starting_tariff) !== 0
            ? taxiAirportConfig.starting_tariff
            : starting_tariff_airline
        let airline_taxi_fee = this.airline && this.airline.taxi_fee ? this.airline.taxi_fee : 0
        let waiting_tarif =
          this.airline && this.airline.params && this.airline.params.taxi_waiting_tarif
            ? this.airline.params.taxi_waiting_tarif
            : 10

        priceTaxi = parseFloat(km_rate) * parseFloat(distance.toFixed(2)) + parseFloat(starting_tariff)
      }
      this.taxiPrice = priceTaxi ? priceTaxi.toFixed(2) : 0
      this.totalPrice = this.taxiPrice * parseInt(this.way_option)
      this.distanceTaxi = distance ? distance.toFixed(2) : 0
    },
    changePreferedTimePickUp(timePickup) {
      this.timePickup = timePickup
    },
    toggleNextDayState(state) {
      this.nextDay = state
    },
    getDirection: async function () {
      let self = this
      if (this.directionsDisplay != null) {
        this.directionsDisplay.setMap(null)
        this.directionsDisplay = null
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer()
      this.directionsService = new google.maps.DirectionsService()
      //google maps API's direction service
      function calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination) {
        return new Promise((resolve, reject) => {
          directionsService.route(
            {
              origin: start,
              destination: destination,
              travelMode: google.maps.TravelMode.DRIVING
            },
            (response, status) => {
              if (status === 'OK') {
                directionsDisplay.setDirections(response)
                const route = response.routes[0]
                resolve(route)
              } else {
                window.alert('Directions request failed due to ' + status)
              }
            }
          )
        })
      }

      let from = {
        lat: parseFloat(this.destination.lat),
        lng: parseFloat(this.destination.lng)
      }
      let to = {
        lat: parseFloat(this.origin.lat),
        lng: parseFloat(this.origin.lng)
      }
      let route = null
      if (!_.isEmpty(from) && !_.isEmpty(to)) {
        route = await calculateAndDisplayRoute(this.directionsService, this.directionsDisplay, from, to)
        if (self.indexBooking != 1) {
          this.distanceHotelToAirport = route.legs[0].distance.value / 1000
          this.distanceAirportToHotel = this.distanceTaxi
        } else {
          this.distanceAirportToHotel = route.legs[0].distance.value / 1000
          this.distanceHotelToAirport = this.distanceTaxi
        }
      } else {
        this.distance = 0
      }
      this.calculatePriceTwoWay()
      return route
    },
    calculatePriceTwoWay() {
      let overnight_station = this.overnightStation
      let taxiConfig = this.airline.params.airline_config_taxi
      let taxiAirportConfig = overnight_station.airline_airport_detail
      let km_rate_airline = Number(taxiConfig.km_rate) !== 0 ? taxiConfig.km_rate : 3
      let starting_tariff_airline = Number(taxiConfig.starting_tariff) !== 0 ? taxiConfig.starting_tariff : 0
      let km_rate =
        !_.isEmpty(taxiAirportConfig.km_rate) && Number(taxiAirportConfig.km_rate) !== 0
          ? taxiAirportConfig.km_rate
          : km_rate_airline
      let starting_tariff =
        !_.isEmpty(taxiAirportConfig.starting_tariff) && Number(taxiAirportConfig.starting_tariff) !== 0
          ? taxiAirportConfig.starting_tariff
          : starting_tariff_airline
      this.priceAirportToHotel =
        parseFloat(km_rate) * parseFloat(this.distanceAirportToHotel).toFixed(2) + parseFloat(starting_tariff) ?? 0
      this.priceHotelToAirport =
        parseFloat(km_rate) * parseFloat(this.distanceHotelToAirport).toFixed(2) + parseFloat(starting_tariff) ?? 0
      this.totalPrice = this.priceAirportToHotel + this.priceHotelToAirport
    }
  }
}
</script>
